module.exports = __webpack_public_path__ + "static/media/45.43570cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/45.jpg
// module id = 305
// module chunks = 0